import { mapper } from '@maia/icons';
import { ClaimDto } from '@maia/shared';
import { FeaturedIcon, Typography } from '../../../ui';
import { BaseCardProps, CardBase } from './base';

interface ClaimCardProps extends BaseCardProps {
  readonly claim: ClaimDto;
}

export function ClaimCard(props: ClaimCardProps) {
  const { claim, ...rest } = props;
  return (
    <CardBase {...rest}>
      <Typography
        variant="body-xs"
        weight="medium"
        className="text-primaryMain"
      >
        {claim.reference}
      </Typography>
      <div className="flex items-center gap-x-14 flex-grow">
        <FeaturedIcon
          icon={mapper(claim.insurance.icon)}
          variant="light-square"
        />
        <div className="flex flex-col">
          <Typography
            variant="body-xs"
            weight="medium"
            className="text-primaryMain"
          >
            {claim.insurance.title}
          </Typography>
          <Typography
            variant="body-xs"
            weight="regular"
            className="text-grayscale300"
          >
            {claim.customer.consumer.fullName}
          </Typography>
        </div>
      </div>
    </CardBase>
  );
}
